import React from 'react'
import * as Displays from 'support/displays'

function SpecialDaysSmartviewHeader (props) {
  const {
    date
  } = props

  return (
    <>{date.format('D. MMM Y')} <Displays.Image name='weather.symbol_url' /></>
  )
}

export default SpecialDaysSmartviewHeader
